import { Shop } from "../../shops/domain/Shop";
import { Order } from "./Order";
import { Tracking } from "./Tracking";

export abstract class OrderRepository{
    abstract ofShop(shop: Shop, sinceId?: Order | boolean): Promise<[Order[], Order | boolean]>;
    abstract addTracking(order: Order, trackingNumber: Tracking):any;
    abstract ofId(id: string, shop: Shop): Promise<Order>;
    abstract cancel(order: Order): Promise<any>;
}